
import { gsap } from "gsap"
import {setCookie, awdScroll} from './bundle'
class CookiePopup{
    constructor(popup){
        this.popup = popup
        this.closeBtn = this.popup.querySelector('.cookie-popup__close-btn')
        this.cta = this.popup.querySelector('.cookie-popup__cta')

        // this.cookieDuration = 60*1000 * 60 * 72
        this.cookieDuration = 10*1000

        this.isAnimating = false

        this.initEvents()
    }

    initEvents(){
        // console.log(document.cookie.indexOf('cookie-popup'))
        // if (document.cookie.indexOf('cookie-popup') < 0) {
        //     // var a = new Date(),
        //     // b = new Date("2024-09-15"), //fino al
        //     // difference = this.dateDiffInDays(a, b)
    
        //     // if(difference >= 0){
        //         awdScroll.stop()
        //         setCookie('cookie-popup', this.cookieDuration)
        //         this.showPopup()                
        //     // }            
        // }
        // else{
        //     // console.log('popup già visto, non faccio nulla')
        // }

        if (document.cookie.indexOf("visited=") >= 0) {
            // L'utente era già entrato almeno una volta negli ultimi 5 minuti.
            console.log('gia visitato')
          }
          else {
              // L'utente è almeno da 5 minuti che non visita il sito
                console.log('prima visita')
                var expiry = new Date();
                var unMinuto = 60*1000;
                // expiry.setTime(expiry.getTime()+(unMinuto/3)); //30 secondi
                // expiry.setTime(expiry.getTime()+(60*unMinuto)); //un'ora
                // expiry.setTime(expiry.getTime()+(60*unMinuto*24)); //un giorno
                expiry.setTime(expiry.getTime()+(60*unMinuto*96)); //4 giorni
    
                //Creo il cookie 'visited' e lo setto a 'yes'. Infine ne imposto la scadenza
                document.cookie = "visited=yes; expires=" + expiry.toGMTString();
                setTimeout(() => {
                    awdScroll.stop()
                    setCookie('cookie-popup', this.cookieDuration)
                    this.showPopup()
                },1000)
          }

        this.cta.addEventListener('click', () => {
            if(this.isAnimating) return
            this.isAnimating = true
            setTimeout(() => {
                this.hidePopup()
                awdScroll.start()
                this.isAnimating = false
            },1000)
        })
        this.closeBtn.addEventListener('click', () => {
            if(this.isAnimating) return
            this.isAnimating = true
            this.fadeOutPopup()
        })
    }

    showPopup(){
        console.log('show popup')
        gsap.set(this.popup, {
            y: '0%'
        })
        // setTimeout(() => {
        //     this.hidePopup()
        // },4000)
    }

    hidePopup(){
        gsap.set(this.popup, {
            y: '-100%'
        })
    }
    
    fadeOutPopup(){
        gsap.to(this.popup, {
            autoAlpha: 0,
            duration: 0.8,
            onComplete: () => {
                this.hidePopup()
                awdScroll.start()
                this.isAnimating = false
            }
        })
    }

    dateDiffInDays(a, b) {
        let _MS_PER_DAY = 1000 * 60 * 60 * 24;
    
        // Discard the time and time-zone information.
        let utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
        let utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
    
        // return Math.floor((utc2 - utc1) / _MS_PER_DAY);
        return Math.floor((utc2 - utc1) / _MS_PER_DAY);
    }    
}

export {CookiePopup}